import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

const DeleteUbicationModal = ({
  ubicationName,
  ubicationId,
  showDeleteModal,
  setShowDeleteModal,
  handleDeleteUbication
}) => {
  const deleteLineWorkReport = async () => {
    await handleDeleteUbication(ubicationId);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => setShowDeleteModal(false)}
      primaryAction={() => {
        deleteLineWorkReport();
        setShowDeleteModal(false);
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => setShowDeleteModal(false)}
      secondaryActionLabel="Salir"
      show={showDeleteModal}
      size="md"
      title="Eliminar"
      variantHeader="danger"
    >
      <div className="modal_body_error">
        ¿Querés eliminar la <strong>{`"Ubicación ${ubicationName}"`}</strong>?
      </div>
    </ModalGeneric>
  );
};

DeleteUbicationModal.propTypes = {
  ubicationName: PropTypes.string.isRequired,
  ubicationId: PropTypes.number.isRequired,
  showDeleteModal: PropTypes.bool.isRequired,
  setShowDeleteModal: PropTypes.func.isRequired,
  handleDeleteUbication: PropTypes.func.isRequired
};

export default DeleteUbicationModal;
